import servicesActionTypes from './action-types';

export const fetchSpecialities = () => ({
  type: servicesActionTypes.FETCH_SPECIALITIES,
});

export const fetchSpecialitiesSuccess = payload => ({
  type: servicesActionTypes.FETCH_SPECIALITIES_SUCCESS,
  payload,
});

export const fetchSpecialitiesFail = payload => ({
  type: servicesActionTypes.FETCH_SPECIALITIES_FAIL,
  payload,
});

export const fetchServicesList = payload => ({
  type: servicesActionTypes.FETCH_SERVICES_LIST,
  payload,
});

export const fetchServicesListSuccess = payload => ({
  type: servicesActionTypes.FETCH_SERVICES_LIST_SUCCESS,
  payload,
});

export const fetchServicesListFail = payload => ({
  type: servicesActionTypes.FETCH_SERVICES_LIST_FAIL,
  payload,
});

export const addOrEditService = payload => ({
  type: servicesActionTypes.ADD_OR_EDIT_SERVICE,
  payload,
});

export const addOrEditServiceSuccess = payload => ({
  type: servicesActionTypes.ADD_OR_EDIT_SERVICE_SUCCESS,
  payload,
});

export const addOrEditServiceFail = payload => ({
  type: servicesActionTypes.ADD_OR_EDIT_SERVICE_FAIL,
  payload,
});

export const resetAddOrEditService = () => ({
  type: servicesActionTypes.RESET_ADD_OR_EDIT_SERVICE,
});

export const deleteService = payload => ({
  type: servicesActionTypes.DELETE_SERVICE,
  payload,
});

export const deleteServiceSuccess = payload => ({
  type: servicesActionTypes.DELETE_SERVICE_SUCCESS,
  payload,
});

export const deleteServiceFail = payload => ({
  type: servicesActionTypes.DELETE_SERVICE_FAIL,
  payload,
});
